import { useTranslation } from 'react-i18next';

// Aktif dili normalize eder ('tr' | 'en') — pick()/format için.
export const useLang = (): 'tr' | 'en' => {
  const { i18n } = useTranslation();
  return i18n.language === 'en' ? 'en' : 'tr';
};
